<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path
                d="M18.35 41.7L15.15 36.25L8.95 35L9.55 28.7L5.5 24L9.55 19.3L8.95 13.05L15.15 11.75L18.35 6.3L24 8.75L29.65 6.3L32.9 11.75L39.1 13.05L38.45 19.3L42.5 24L38.45 28.7L39.1 35L32.9 36.25L29.65 41.7L24 39.25L18.35 41.7ZM18.85 40.25L24 38.15L29.2 40.25L32.25 35.4L37.85 34.1L37.35 28.3L41.15 24L37.35 19.7L37.85 13.85L32.25 12.6L29.2 7.75L24 9.85L18.8 7.75L15.75 12.6L10.15 13.85L10.65 19.7L6.85 24L10.65 28.3L10.15 34.1L15.75 35.4L18.85 40.25ZM21.9 29.15L31.4 19.7L30.55 18.95L21.9 27.6L17.45 23.05L16.6 23.9L21.9 29.15Z"
                fill="currentColor" />
        </g>
    </svg>
</template>

<style lang="sass">
</style>